import { TraceabilityTagDto } from '../_generated/api/tagged-hardware'
import ApiModel from './ApiModel'

export default class TraceabilityTag extends ApiModel<TraceabilityTagDto> {
    get tagId() {
        return this.data.tagId ?? ''
    }
}
